module.exports = __webpack_public_path__ + "img/footer_QRcode.da644e36.png";